import axios from 'axios'
import { useEffect, useState } from 'react'

let evidentlyFeatures: Record<string, boolean> | undefined
let evidentlyFeaturesPromise

const init = async () => {
  try {
    const { data } = await axios.get('/composer/api/v2/features')
    evidentlyFeatures = data
    return data
  } catch (e) {
    console.error('could not get evidently feature flags')
    return {}
  }
}

const getEvidentlyFeatures = async (): Promise<
  Record<string, boolean> | undefined
> => {
  if (evidentlyFeatures) return evidentlyFeatures
  if (evidentlyFeaturesPromise) return evidentlyFeaturesPromise

  evidentlyFeaturesPromise = init()
  return evidentlyFeaturesPromise
}

const useEvidentlyFeatures = () => {
  const [flags, setFlags] = useState<Record<string, boolean> | undefined>({})

  useEffect(() => {
    const loadFlags = async () => {
      const resolved = await getEvidentlyFeatures()
      setFlags(resolved)
    }
    loadFlags()
  }, [])

  return flags
}

/**
 * Synchronously returns the cached Evidently features if available.
 * Returns undefined if features haven't been loaded yet.
 * Use this in mapStateToProps or other synchronous contexts.
 */
const getEvidentlyFeaturesSync = (): Record<string, boolean> | undefined => {
  return evidentlyFeatures
}

export { getEvidentlyFeatures, useEvidentlyFeatures, getEvidentlyFeaturesSync }
